import { createSlice } from "@reduxjs/toolkit";

const announcementCountSlice = createSlice({
  name: "announcementCount",
  initialState: {
    count: 0,
    initialized: false,
  },
  reducers: {
    setAnnouncementCount: (state, action) => {
      state.count = action.payload;
      state.initialized = true;
    },
    seedAnnouncementCount: (state, action) => {
      if (!state.initialized) {
        state.count = action.payload;
      }
    },
    incrementAnnouncementCount: (state) => {
      state.count += 1;
    },
  },
});

export const {
  setAnnouncementCount,
  seedAnnouncementCount,
  incrementAnnouncementCount,
} = announcementCountSlice.actions;

export default announcementCountSlice.reducer;
